var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0271 13.8476L18.5963 17.4159L17.4171 18.5951L13.8488 15.0259C12.5211 16.0903 10.8696 16.6692 9.16797 16.6667C5.02797 16.6667 1.66797 13.3067 1.66797 9.16675C1.66797 5.02675 5.02797 1.66675 9.16797 1.66675C13.308 1.66675 16.668 5.02675 16.668 9.16675C16.6704 10.8684 16.0915 12.5199 15.0271 13.8476ZM13.3555 13.2292C14.4131 12.1417 15.0037 10.6838 15.0013 9.16675C15.0013 5.94341 12.3905 3.33341 9.16797 3.33341C5.94463 3.33341 3.33464 5.94341 3.33464 9.16675C3.33464 12.3892 5.94463 15.0001 9.16797 15.0001C10.685 15.0025 12.1429 14.4118 13.2305 13.3542L13.3555 13.2292Z",
    fill: "#2A3842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.321fe786ed174020eec3b91d3c8064de.svg";
export { ForwardRef as ReactComponent };